import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
export function Filters(_ref) {
  var _filters$;

  var engine = _ref.engine,
      filters = _ref.filters;

  var _React$useState = React.useState((_filters$ = filters[0]) === null || _filters$ === void 0 ? void 0 : _filters$.filterSlug),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var numberSelectedFilter = getNumberSelectedFilters(engine.query); // Séparation en deux pane différent
  // parce que le mobile pane utilise overlay
  // et cela pose des soucis sur desktop

  return __jsx(FilterContainer, null, __jsx(MobilePane, {
    engine: engine,
    filters: filters,
    focused: focused,
    numberSelectedFilter: numberSelectedFilter,
    setFocused: setFocused
  }), __jsx(DesktopPane, {
    engine: engine,
    filters: filters,
    focused: focused,
    numberSelectedFilter: numberSelectedFilter,
    setFocused: setFocused
  }));
}

function MobilePane(_ref2) {
  var engine = _ref2.engine,
      filters = _ref2.filters,
      focused = _ref2.focused,
      numberSelectedFilter = _ref2.numberSelectedFilter,
      setFocused = _ref2.setFocused;

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openPane = _React$useState4[0],
      setOpenPane = _React$useState4[1];

  return __jsx(MobilePanContainer, null, __jsx(ds.Button, {
    onClick: function onClick() {
      setOpenPane(true);
      setFocused(undefined);
    },
    iconLeft: __jsx(ds.icons.Filter, null),
    outlined: true
  }, engine.ready ? "Filtrer".concat(numberSelectedFilter > 0 ? " (".concat(numberSelectedFilter, ")") : '') : 'Chargement'), openPane && __jsx(Pane, null, __jsx(FilterHeading, null, __jsx(S.heading.TitleCard, null, "Filtres"), Object.keys(engine.query.value.filters).length !== 0 && __jsx(ds.Button, {
    as: S.link.Base,
    onClick: function onClick() {
      return engine.query.reset();
    }
  }, "R\xE9initialiser les filtres"), __jsx(ButtonClose, {
    onClick: function onClick() {
      setOpenPane(false);
    }
  }, __jsx(ds.icons.Cross, {
    size: 20
  }))), __jsx(FilterList, {
    filters: filters,
    focused: focused,
    engine: engine,
    setFocused: setFocused
  }), __jsx(BackButton, {
    onClick: function onClick() {
      setFocused(undefined);
      setOpenPane(false);
    }
  }, "Voir toute la s\xE9lection (", engine.result.total, ")")));
}

function DesktopPane(_ref3) {
  var engine = _ref3.engine,
      filters = _ref3.filters,
      focused = _ref3.focused,
      numberSelectedFilter = _ref3.numberSelectedFilter,
      setFocused = _ref3.setFocused;
  return __jsx(DesktopPaneContainer, null, __jsx(ds.Button, {
    onClick: function onClick() {
      setFocused('');
    },
    iconLeft: __jsx(ds.icons.Filter, null)
  }, "Filtrer ", numberSelectedFilter > 0 && "(".concat(numberSelectedFilter, ")")), __jsx(React.Fragment, null, __jsx(FilterHeading, null, engine.ready ? filters.length > 0 && __jsx(S.heading.TitleCard, null, "Filtres") : __jsx(S.heading.TitleCard, null, "Filtres"), Object.keys(engine.query.value.filters).length !== 0 && __jsx(ds.Button, {
    as: S.link.Base,
    onClick: function onClick() {
      return engine.query.reset();
    }
  }, "R\xE9initialiser les filtres")), __jsx(FilterList, {
    filters: filters,
    focused: focused,
    engine: engine,
    setFocused: setFocused
  })));
}

function FilterList(_ref4) {
  var _ref4$engine = _ref4.engine,
      query = _ref4$engine.query,
      ready = _ref4$engine.ready,
      filters = _ref4.filters,
      focused = _ref4.focused,
      setFocused = _ref4.setFocused;
  return __jsx(FilterWrapper, null, !ready && Array.from({
    length: 5
  }, function (_, i) {
    return __jsx(FilterSkeleton, {
      key: i
    });
  }), ready && filters.map(function (_ref5, index) {
    var filterSlug = _ref5.filterSlug,
        filterTitle = _ref5.filterTitle,
        filterValues = _ref5.filterValues;
    return __jsx(ds.Filter, {
      onToggle: function onToggle(open) {
        if (!open) {
          setFocused('');
        } else {
          setFocused(filterSlug);
        }
      },
      open: focused === filterSlug,
      key: index,
      title: filterTitle,
      filters: filterValues,
      onSelectionChange: function onSelectionChange(name, add) {
        if (add) {
          query.add(filterSlug, name);
        } else {
          query.remove(filterSlug, name);
        }
      }
    });
  }));
}

function getNumberSelectedFilters(query) {
  var selectedFilters = query.value.filters;
  return Object.values(selectedFilters).reduce(function (totalLength, filters) {
    return totalLength + filters.length;
  }, 0);
}

var MobilePanContainer = styled.div.withConfig({
  displayName: "Filters__MobilePanContainer",
  componentId: "sc-19x0dyi-0"
})(["display:none;@media not screen and (", "){display:block;}"], ds.breakpoint.TABLET);
var DesktopPaneContainer = styled.div.withConfig({
  displayName: "Filters__DesktopPaneContainer",
  componentId: "sc-19x0dyi-1"
})(["display:block;@media not screen and (", "){display:none;}"], ds.breakpoint.TABLET);
var BackButton = styled(ds.Button).withConfig({
  displayName: "Filters__BackButton",
  componentId: "sc-19x0dyi-2"
})(["bottom:0;left:0;margin:25px;position:fixed;z-index:2;@media screen and (", "){display:none;}"], ds.breakpoint.TABLET);
var ButtonClose = styled(S.button.UnstyledButton).withConfig({
  displayName: "Filters__ButtonClose",
  componentId: "sc-19x0dyi-3"
})(["position:absolute;right:0;top:2px;"]);
var FilterHeading = styled.div.withConfig({
  displayName: "Filters__FilterHeading",
  componentId: "sc-19x0dyi-4"
})(["position:relative;", "{margin-bottom:16px;}", "{text-align:right;}@media screen and (", "){align-items:center;display:flex;width:100%;", "{margin-bottom:0;flex:1;}}"], S.heading.TitleCard, ds.Button, ds.breakpoint.TABLET, S.heading.TitleCard);
var FilterContainer = styled.div.withConfig({
  displayName: "Filters__FilterContainer",
  componentId: "sc-19x0dyi-5"
})(["flex:1;margin-right:3px;", "{cursor:pointer;}", "{width:100%;}", "{width:calc(100% - 50px);}@media screen and (", "){margin-top:25px;", "{display:none;}", "{display:none;}", "{display:block;}}"], S.link.Base, ds.Button, BackButton, ds.breakpoint.TABLET, ds.Button, ButtonClose, S.link.Base);
var FilterWrapper = styled.div.withConfig({
  displayName: "Filters__FilterWrapper",
  componentId: "sc-19x0dyi-6"
})(["margin-top:23px;", "{background-color:", ";border-radius:10px;margin-bottom:10px;padding:15px 0;}", "{padding:0 18px;}@media screen and (", "){margin-top:10px;", "{margin-top:5px;}", "{padding:0;}", "{padding:15px 18px;}}"], S.filter.AccordionWrapper, ds.color.SAND_2, S.accordion.Title, ds.breakpoint.TABLET, S.accordion.Content, S.accordion.Title, S.filter.AccordionWrapper);
var Pane = styled(ds.Overlay).withConfig({
  displayName: "Filters__Pane",
  componentId: "sc-19x0dyi-7"
})(["@media not screen and (", "){display:block;background-color:", ";height:100%;left:0;padding:25px;position:fixed;top:", ";width:100vw;z-index:2;}"], ds.breakpoint.TABLET, ds.color.SAND_1, ds.sizes.HEADER_MOBILE_INTERNAL_HEIGHT);
/* skeleton */

function FilterSkeletonComponent() {
  return __jsx(ds.Filter, {
    title: __jsx(ds.styles.skeleton.Text, {
      size: "small",
      width: 80
    }),
    filters: [],
    open: false,
    onSelectionChange: function onSelectionChange() {
      return null;
    },
    onToggle: function onToggle() {
      return null;
    }
  });
}

export var FilterSkeleton = styled(FilterSkeletonComponent).withConfig({
  displayName: "Filters__FilterSkeleton",
  componentId: "sc-19x0dyi-8"
})([""]);